export default __webpack_public_path__ + "static/media/user_list.eb1af30d.svg";